<ion-item
  (click)="onClick()"
  [button]="true"
  [detail]="!withItemStatus"
  [ngClass]="{ selected: selectableItem.selected }"
  class="list-item container-outline"
  lines="none">
  @if (showStatus) {
    <rc-item-status-icon [itemStatus]="selectableItem.status" slot="start"></rc-item-status-icon>
  }

  <ion-thumbnail slot="start">
    @if (selectableItem.image) {
      <cdn-img [src]="selectableItem.image" alt="item-thumbnail" class="ion-no-padding" size="xs" />
    }
    @if (!selectableItem.image) {
      <ion-icon name="camera-outline"></ion-icon>
    }
  </ion-thumbnail>

  <div class="full-width">
    <ion-label class="item-id ion-margin-left"># {{ selectableItem.numberId }}</ion-label>
    <ion-label class="item-category ion-margin-left ion-text-wrap">
      {{ itemCategoryToString(selectableItem.category) }}
    </ion-label>
    @if (itemNameToString(selectableItem); as itemName) {
      <ion-label class="item-name ion-margin-left ion-text-wrap">{{ itemName }}</ion-label>
    }
    @if (mode !== "read" && selectableItem.selected) {
      <ion-text class="included-text ion-margin-left">Tap to remove</ion-text>
    }
    @if (mode !== "read" && !selectableItem.selected) {
      <ion-text class="excluded-text ion-margin-left">Tap to add</ion-text>
    }
  </div>

  @if (!showScanButton) {
    <ion-badge slot="end">{{ rackToString(selectableItem) }}</ion-badge>
  }

  @if (showScanButton) {
    <ion-button
      (click)="navigationService.goToScanRackForItemPage(selectableItem.id); $event.stopPropagation()"
      class="scan-button"
      color="secondary"
      size="large"
      slot="end">
      <ion-icon class="scan-icon" name="scan-outline"></ion-icon>
    </ion-button>
  }
</ion-item>
